import { detectTemplate, parseSSEEvents } from "./planny-logic.js";

(function () {
  const CONFIG = Object.assign({ apiUrl: "" }, window.PLANNY_CONFIG || {});
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const ASSETS = {
    idle: new URL("planny-idle.png", import.meta.url).href,
    wave: new URL("planny-wave.png", import.meta.url).href,
    blink: new URL("planny-blink.png", import.meta.url).href,
    walk: new URL("planny-walk.png", import.meta.url).href,
  };

  const style = document.createElement("style");
  style.textContent = `
    :root { --planny-size: 110px; }
    @media (max-width: 640px) { :root { --planny-size: 82px; } }
    #planny-pos { position: fixed; right: 18px; bottom: 18px; width: var(--planny-size); height: var(--planny-size); z-index: 2147483000; pointer-events: auto; transition: transform 0.18s ease; }
    #planny-pos.planny-noticing { transform: scale(1.06) rotate(-3deg); }
    #planny-btn { all: unset; display: block; width: 100%; height: 100%; cursor: pointer; filter: drop-shadow(0 8px 14px rgba(20,40,28,0.28)); }
    #planny-bob-wrap { position: relative; width: 100%; height: 100%; transform-origin: 50% 92%; animation: planny-bob 2.6s ease-in-out infinite; }
    .planny-sprite { position: absolute; inset: 0; display: block; width: 100%; height: 100%; object-fit: contain; user-select: none; -webkit-user-drag: none; opacity: 0; transition: opacity 0.32s ease; }
    .planny-sprite.planny-front { opacity: 1; }
    #planny-pos.planny-blinking .planny-sprite { transition: opacity 0.09s linear; }
    @keyframes planny-bob { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-6px); } }
    #planny-pos.planny-excited #planny-bob-wrap { animation: planny-hop 0.5s ease; }
    @keyframes planny-hop { 0% { transform: translateY(0) scale(1); } 35% { transform: translateY(-18px) scale(1.05,0.95); } 60% { transform: translateY(0) scale(0.97,1.05); } 100% { transform: translateY(0) scale(1); } }
    @media (prefers-reduced-motion: reduce) { #planny-bob-wrap { animation: none !important; } .planny-sprite { transition: none; } #planny-pos.planny-blinking .planny-sprite { transition: none; } }
    #planny-pos.planny-walking #planny-bob-wrap { animation: planny-walk-shuffle 0.9s ease-in-out; }
    @keyframes planny-walk-shuffle { 0%, 100% { transform: translateY(0) translateX(0); } 20% { transform: translateY(-5px) translateX(-3px); } 50% { transform: translateY(0) translateX(0); } 80% { transform: translateY(-5px) translateX(3px); } }
    .planny-bubble { position: absolute; right: 0; left: auto; bottom: calc(100% + 12px); max-width: 220px; background: #fff; color: #1e2a20; border: 1px solid rgba(30,42,32,0.13); border-radius: 16px; padding: 12px 15px; font-size: 14px; line-height: 1.45; box-shadow: 0 10px 30px rgba(20,40,28,0.14); pointer-events: none; opacity: 0; transform: translateY(6px) scale(0.94); transition: opacity 0.22s ease, transform 0.22s ease; }
    .planny-bubble.planny-visible { opacity: 1; transform: translateY(0) scale(1); }
    .planny-bubble::after { content: ""; position: absolute; bottom: -7px; right: 22px; width: 14px; height: 14px; background: #fff; border-right: 1px solid rgba(30,42,32,0.13); border-bottom: 1px solid rgba(30,42,32,0.13); transform: rotate(45deg); }
    #planny-chat { position: fixed; right: 18px; bottom: calc(var(--planny-size) + 34px); width: min(360px, calc(100vw - 28px)); max-height: min(560px, calc(100vh - var(--planny-size) - 80px)); background: #fff; border: 1px solid rgba(30,42,32,0.13); border-radius: 22px; box-shadow: 0 20px 50px rgba(20,40,28,0.22); z-index: 2147483001; display: flex; flex-direction: column; overflow: hidden; transform: translateY(24px) scale(0.97); opacity: 0; pointer-events: none; transition: opacity 0.24s ease, transform 0.24s ease; }
    #planny-chat.planny-open { opacity: 1; transform: translateY(0) scale(1); pointer-events: auto; }
    .planny-chat-head { display: flex; align-items: center; gap: 10px; padding: 14px 16px; background: linear-gradient(135deg, #3e8a5e, #1f5c3e); color: #fbf6e7; }
    .planny-chat-head strong { display: block; font-size: 14.5px; }
    .planny-chat-close { all: unset; cursor: pointer; margin-left: auto; width: 28px; height: 28px; display: flex; align-items: center; justify-content: center; border-radius: 50%; font-size: 16px; }
    .planny-chat-body { flex: 1; overflow-y: auto; padding: 16px; display: flex; flex-direction: column; gap: 10px; background: #f2eee0; }
    .planny-msg { max-width: 82%; padding: 10px 13px; border-radius: 14px; font-size: 14px; line-height: 1.5; }
    .planny-msg.planny-bot { align-self: flex-start; background: #fff; border: 1px solid rgba(30,42,32,0.13); }
    .planny-msg.planny-user { align-self: flex-end; background: #3e8a5e; color: #fbf6e7; }
    .planny-chat-input { display: flex; gap: 8px; padding: 12px; border-top: 1px solid rgba(30,42,32,0.13); background: #fff; }
    .planny-chat-input input { flex: 1; border: 1px solid rgba(30,42,32,0.13); border-radius: 999px; padding: 10px 14px; font-size: 14px; font-family: inherit; }
    .planny-chat-input button { all: unset; cursor: pointer; background: #3e8a5e; color: #fbf6e7; width: 38px; height: 38px; border-radius: 50%; display: flex; align-items: center; justify-content: center; }
    .planny-product-card { display: flex; gap: 12px; align-self: flex-start; max-width: 92%; background: #fff; border: 1px solid rgba(30,42,32,0.13); border-radius: 14px; padding: 10px; }
    .planny-product-image { width: 64px; height: 64px; object-fit: cover; border-radius: 10px; flex-shrink: 0; background: #f2eee0; }
    .planny-product-info { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
    .planny-product-title { font-size: 13.5px; font-weight: 600; color: #1e2a20; }
    .planny-product-price { font-size: 13px; color: #3e8a5e; font-weight: 600; }
    .planny-product-actions { display: flex; gap: 6px; flex-wrap: wrap; margin-top: 4px; }
    .planny-product-link { all: unset; cursor: pointer; font-size: 12.5px; padding: 6px 10px; border-radius: 999px; border: 1px solid #3e8a5e; color: #1f5c3e; }
    .planny-product-cart { all: unset; cursor: pointer; font-size: 12.5px; padding: 6px 10px; border-radius: 999px; background: #3e8a5e; color: #fbf6e7; }
    .planny-product-cart:disabled { opacity: 0.7; cursor: default; }
    .planny-product-unavailable { font-size: 12.5px; color: #8a5a4a; align-self: center; }
  `;
  document.head.appendChild(style);

  const posEl = document.createElement("div");
  posEl.id = "planny-pos";
  posEl.innerHTML = `
    <div id="planny-bubble" class="planny-bubble" role="status" aria-live="polite"></div>
    <button id="planny-btn" aria-label="Apri la chat con Planny">
      <div id="planny-bob-wrap">
        <img id="planny-img-a" class="planny-sprite planny-front" src="${ASSETS.idle}" alt="Planny" draggable="false" />
        <img id="planny-img-b" class="planny-sprite" src="${ASSETS.idle}" alt="" draggable="false" />
      </div>
    </button>
  `;
  document.body.appendChild(posEl);

  const chatPanel = document.createElement("div");
  chatPanel.id = "planny-chat";
  chatPanel.innerHTML = `
    <div class="planny-chat-head">
      <strong>Planny · Chiedi alla Natura</strong>
      <button class="planny-chat-close" id="planny-chat-close" aria-label="Chiudi chat">✕</button>
    </div>
    <div class="planny-chat-body" id="planny-chat-body">
      <div class="planny-msg planny-bot">Ciao 🌿 Sono Planny. Posso aiutarti a scegliere il prodotto giusto, spiegarti ingredienti e benefici, o rispondere a domande sul negozio.</div>
    </div>
    <form class="planny-chat-input" id="planny-chat-form">
      <input type="text" id="planny-chat-text" placeholder="Scrivi un messaggio…" autocomplete="off" />
      <button type="submit" aria-label="Invia">➤</button>
    </form>
  `;
  document.body.appendChild(chatPanel);

  const bubbleEl = document.getElementById("planny-bubble");
  const layerA = document.getElementById("planny-img-a");
  const layerB = document.getElementById("planny-img-b");

  // Preload every sprite once so the first crossfade to each pose is instant.
  Object.values(ASSETS).forEach((src) => {
    const preload = new Image();
    preload.src = src;
  });

  let frontLayer = layerA;
  let backLayer = layerB;
  function crossfadeTo(src) {
    backLayer.src = src;
    backLayer.classList.add("planny-front");
    frontLayer.classList.remove("planny-front");
    const swap = frontLayer;
    frontLayer = backLayer;
    backLayer = swap;
  }

  let currentSprite = "idle";
  let isBlinking = false;
  function setSprite(name) {
    if (isBlinking || currentSprite === name) return;
    currentSprite = name;
    crossfadeTo(ASSETS[name]);
  }

  let paused = false;

  function scheduleBlink() {
    const delay = 2600 + Math.random() * 2600;
    setTimeout(() => {
      isBlinking = true;
      posEl.classList.add("planny-blinking");
      crossfadeTo(ASSETS.blink);
      setTimeout(() => {
        isBlinking = false;
        crossfadeTo(ASSETS[currentSprite]);
        setTimeout(() => posEl.classList.remove("planny-blinking"), 90);
      }, 260);
      scheduleBlink();
    }, delay);
  }
  scheduleBlink();

  function scheduleWalk() {
    const delay = 14000 + Math.random() * 8000;
    setTimeout(() => {
      if (!reduceMotion && !paused && !isBlinking && currentSprite === "idle") {
        setSprite("walk");
        posEl.classList.add("planny-walking");
        setTimeout(() => {
          posEl.classList.remove("planny-walking");
          if (currentSprite === "walk") {
            currentSprite = "idle";
            if (!isBlinking) crossfadeTo(ASSETS.idle);
          }
        }, 900);
      }
      scheduleWalk();
    }, delay);
  }
  scheduleWalk();

  window.__plannyState = {
    get paused() { return paused; },
    set paused(v) { paused = v; },
    excite() {
      posEl.classList.remove("planny-excited");
      void posEl.offsetWidth;
      posEl.classList.add("planny-excited");
    },
    currentTemplate() { return detectTemplate(window.location.pathname); },
  };

  const history = [];

  function appendMessage(role, text) {
    const body = document.getElementById("planny-chat-body");
    const el = document.createElement("div");
    el.className = `planny-msg planny-${role === "user" ? "user" : "bot"}`;
    el.textContent = text;
    body.appendChild(el);
    body.scrollTop = body.scrollHeight;
    return el;
  }

  function escapeHtml(str) {
    return String(str ?? "").replace(/[&<>"']/g, (ch) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
    }[ch]));
  }

  function appendProductCard(product) {
    const body = document.getElementById("planny-chat-body");
    const card = document.createElement("div");
    card.className = "planny-product-card";
    const imageHtml = product.image
      ? `<img class="planny-product-image" src="${escapeHtml(product.image.url)}" alt="${escapeHtml(product.image.alt)}" />`
      : "";
    const actionHtml = product.available && product.cartVariantId
      ? `<button type="button" class="planny-product-cart" data-variant-id="${escapeHtml(product.cartVariantId)}">Aggiungi al carrello 🛒</button>`
      : `<span class="planny-product-unavailable">Non disponibile</span>`;
    card.innerHTML = `
      ${imageHtml}
      <div class="planny-product-info">
        <div class="planny-product-title">${escapeHtml(product.title)}</div>
        <div class="planny-product-price">${escapeHtml(product.price)}</div>
        <div class="planny-product-actions">
          <a class="planny-product-link" href="${escapeHtml(product.url)}" target="_blank" rel="noopener">Vai al prodotto</a>
          ${actionHtml}
        </div>
      </div>
    `;
    body.appendChild(card);
    body.scrollTop = body.scrollHeight;

    const cartBtn = card.querySelector(".planny-product-cart");
    if (cartBtn) {
      cartBtn.addEventListener("click", async () => {
        cartBtn.disabled = true;
        cartBtn.textContent = "Aggiungo…";
        try {
          const res = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: cartBtn.dataset.variantId, quantity: 1 }),
          });
          if (res.ok) {
            cartBtn.textContent = "Aggiunto! ✓";
          } else {
            cartBtn.textContent = "Errore, riprova";
            cartBtn.disabled = false;
          }
        } catch {
          cartBtn.textContent = "Errore, riprova";
          cartBtn.disabled = false;
        }
      });
    }
  }

  async function streamChat(userText) {
    history.push({ role: "user", content: userText });
    appendMessage("user", userText);

    let botEl = null;
    let botText = "";

    let response;
    try {
      response = await fetch(CONFIG.apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ messages: history }),
      });
    } catch (err) {
      appendMessage("bot", "Sto avendo un problema momentaneo 🌿 riprova tra poco.");
      return;
    }

    if (!response.ok || !response.body) {
      appendMessage("bot", "Sto avendo un problema momentaneo 🌿 riprova tra poco.");
      return;
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const { events, remainder } = parseSSEEvents(buffer);
      buffer = remainder;

      for (const evt of events) {
        if (evt.type === "product") {
          appendProductCard(JSON.parse(evt.data));
        } else if (evt.type === "delta") {
          const payload = JSON.parse(evt.data);
          if (!botEl) botEl = appendMessage("bot", "");
          botText += payload.text;
          botEl.textContent = botText;
          document.getElementById("planny-chat-body").scrollTop = 999999;
        } else if (evt.type === "error") {
          if (!botEl) botEl = appendMessage("bot", "");
          botEl.textContent = "Sto avendo un problema momentaneo 🌿 riprova tra poco.";
        }
      }
    }

    history.push({ role: "assistant", content: botText });
  }

  document.getElementById("planny-chat-form").addEventListener("submit", (e) => {
    e.preventDefault();
    const input = document.getElementById("planny-chat-text");
    const val = input.value.trim();
    if (!val) return;
    input.value = "";
    streamChat(val);
  });

  let chatOpen = false;
  function openChat() {
    chatOpen = true;
    paused = true;
    currentSprite = "idle";
    if (!isBlinking) crossfadeTo(ASSETS.idle);
    chatPanel.classList.add("planny-open");
  }
  function closeChat() {
    chatOpen = false;
    chatPanel.classList.remove("planny-open");
    paused = false;
  }
  let talkTimeout = null;
  function showBubble(text, ms) {
    bubbleEl.textContent = text;
    bubbleEl.classList.add("planny-visible");
    setSprite("wave");
    paused = true;
    clearTimeout(talkTimeout);
    talkTimeout = setTimeout(() => {
      bubbleEl.classList.remove("planny-visible");
      if (!chatOpen) {
        paused = false;
        currentSprite = "idle";
        if (!isBlinking) crossfadeTo(ASSETS.idle);
      }
    }, ms || 3200);
  }

  const sectionTips = {
    index: "Ciao, sono Planny 🌿 Progettiamo il tuo benessere insieme. Chiedimi pure!",
    collection: "Guarda pure con calma 🌿 Se cerchi qualcosa in particolare, chiedimelo.",
    product: "Se vuoi sapere se questo prodotto fa per te, chiedimi pure 🍃",
    other: "Ciao 🌿 Sono Planny, sono qui se hai bisogno di una mano.",
  };
  let lastTipAt = 0;
  setTimeout(() => {
    const tip = sectionTips[detectTemplate(window.location.pathname)];
    if (tip) showBubble(tip, 4200);
    lastTipAt = performance.now();
  }, 900);

  const cartReactions = [
    "Ottima scelta! 🌿 Questo è tra i più amati.",
    "Bella idea 🍃 Vuoi sapere come si usa?",
    "Scelta perfetta se cerchi qualcosa di naturale ✨",
  ];

  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const url = typeof args[0] === "string" ? args[0] : args[0]?.url || "";
    const result = originalFetch.apply(window, args);
    if (url.includes("/cart/add")) {
      result.then((res) => {
        if (res.ok) {
          window.__plannyState.excite();
          showBubble(cartReactions[Math.floor(Math.random() * cartReactions.length)], 3400);
        }
      }).catch(() => {});
    }
    return result;
  };

  window.addEventListener("scroll", () => {
    const now = performance.now();
    if (now - lastTipAt < 12000 || chatOpen || paused) return;
    const path = window.location.pathname;
    const tip = sectionTips[detectTemplate(path)];
    if (tip && Math.random() < 0.02) {
      lastTipAt = now;
      showBubble(tip, 3800);
    }
  }, { passive: true });

  document.getElementById("planny-btn").addEventListener("click", () => {
    chatOpen ? closeChat() : openChat();
  });
  document.getElementById("planny-chat-close").addEventListener("click", closeChat);

  function onHoverStart() {
    posEl.classList.add("planny-noticing");
  }
  function onHoverEnd() {
    posEl.classList.remove("planny-noticing");
  }
  posEl.addEventListener("mouseenter", onHoverStart);
  posEl.addEventListener("mouseleave", onHoverEnd);
  posEl.addEventListener("touchstart", () => {
    onHoverStart();
    setTimeout(onHoverEnd, 900);
  }, { passive: true });
})();
